<div class="added-role-dialog">
  <img
    src="assets/img/success-image.svg"
    alt="Success icon"
    class="success-icon">
  <h2 class="headline">{{'SAVED_CARD_PAGE.MODAL_DELETE_SUCCESS.TITLE' | translate}}</h2>
  <div class="btn-block">
    <button
      (click)="goToRoleList()"
      class="btn btn-link">
      {{'SAVED_CARD_PAGE.MODAL_DELETE_SUCCESS.GO_TO_CARD' | translate}}
    </button>
  </div>
</div>
